import { faTimesCircle } from '@fortawesome/pro-duotone-svg-icons'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { COLOR_ERROR } from 'src/constants/theme'
import { buildTransactionErrorMessage } from '../../../util/rewardBox.helpers'
import FailedStatus from '../common/FailedStatus'

const FailedTransaction = ({ message, title, onSubmit, onCancel }) => {
  const { t } = useTranslation()
  return (
    <FailedStatus
      title={title || t('common.something-went-wrong')}
      description={t(buildTransactionErrorMessage(message))}
      icon={faTimesCircle}
      color={COLOR_ERROR}
      onSubmit={onSubmit}
      onCancel={onCancel}
      t={t}
    />
  )
}

export default memo(FailedTransaction)
